// extracted by css-extract-rspack-plugin
var _1 = "column-name-aR3V0f";
var _2 = "column-name-aR3V0f";
var _3 = "filter-Ifxdc4";
var _4 = "table-YB59D5";
export { _1 as "column-name", _2 as "columnName", _3 as "filter", _4 as "table" }
